import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { List, ListItem } from '@ui/components/List'
import { Modal } from '@ui/components/Modal'
import { IconRendererType } from '@ui/icons/utils/IconRenderer'

export interface ActionsListModalAction {
  label: string
  icon: IconRendererType
  onClick: () => void
}

interface ActionsListModalProps {
  actions: ActionsListModalAction[]
}

export const ActionsListModal: BaseModalType<ActionsListModalProps> = ({ actions, close }) => {
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Body>
        <List>
          {actions.map(({ label, icon, onClick }) => (
            <ListItem key={label} onClick={onClick} startSlot={{ icon, size: 'x20' }}>
              {label}
            </ListItem>
          ))}
        </List>
      </Modal.Body>

      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Close')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
